export default [
    { name: 'USD', symbol: '$' },
    { name: 'EUR', symbol: '€' },
    { name: 'GBP', symbol: '£' },
    { name: 'CHF', symbol: 'Fr' },
    { name: 'AUD', symbol: 'A$' },
    { name: 'CAD', symbol: 'C$' },
    { name: 'BRL', symbol: 'R$' },
    { name: 'NOK', symbol: 'kr' },
    { name: 'MXN', symbol: 'Mex$' },
    { name: 'BTC', symbol: 'BTC ', precision: 8 },
    { name: 'TBTC', symbol: 'TBTC ', precision: 8 },
    { name: 'LTC', symbol: 'LTC ', precision: 8 },
];
